export const loginPageId = 'loginScreen' as const;
